//** Effect Imports
import { useStore } from 'effector-react'

// ** MUI Imports
import { Box } from '@mui/material'

// ** Next Imports
import Link from 'next/link'
import { useRouter } from 'next/router'

// ** Hooks Imports
import { useIntl } from 'react-intl'

// ** Source code Imports
import globalStore from 'src/state-manager/global'
import { PageItem } from 'src/layouts/default-layout/opts'

interface IProps {
  pages: PageItem[]
  handleClose: any
}

const MobileMenuList = ({ pages, handleClose }: IProps) => {
  // ** Hooks
  const { formatMessage } = useIntl()
  const router = useRouter()
  const hash = router.asPath.split('#')[1]

  const { language } = useStore(globalStore.locale)
  const filterePages = language === 'ru' ? pages.filter(item => item.title !== 'partners') : pages

  return (
    <>
      {filterePages?.map(page => {
        const isActiveItem = !hash ? router.pathname === page.link : `#${hash}` === page.link

        return (
          <Box
            onClick={handleClose}
            key={page.id}
            sx={{
              width: 'fit-content',
              borderBottom: isActiveItem ? '1px solid #fff' : 'initial',
              '&.MuiBox-root a': {
                color: '#fff',
                textDecoration: 'none'
              }
            }}
          >
            <Link href={page.link}>{formatMessage({ id: page.title }).toUpperCase()}</Link>
          </Box>
        )
      })}
    </>
  )
}
export default MobileMenuList
